'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _defaultTo2 = require('lodash/defaultTo');

var _defaultTo3 = _interopRequireDefault(_defaultTo2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _TrackPlayPauseButton = require('components/TrackPlayPauseButton/TrackPlayPauseButton');

var _TrackPlayPauseButton2 = _interopRequireDefault(_TrackPlayPauseButton);

var _audioplayer = require('redux/modules/audioplayer');

var audioplayerActions = _interopRequireWildcard(_audioplayer);

var _myPlaylists = require('redux/modules/my-playlists');

var myPlaylistsActions = _interopRequireWildcard(_myPlaylists);

var _ListItem = require('components/ListItem/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

var _TrackDuration = require('components/TrackDuration/TrackDuration');

var _TrackDuration2 = _interopRequireDefault(_TrackDuration);

var _MyPlaylistTrackPopover = require('./MyPlaylistTrackPopover');

var _MyPlaylistTrackPopover2 = _interopRequireDefault(_MyPlaylistTrackPopover);

var _MoreButton = require('components/MoreButton/MoreButton');

var _MoreButton2 = _interopRequireDefault(_MoreButton);

var _MyPlaylistTrackName = require('./MyPlaylistTrackName');

var _MyPlaylistTrackName2 = _interopRequireDefault(_MyPlaylistTrackName);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./MyPlaylistTracks.scss');

var MyPlaylistTrack = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    currentTrackIndex: state.audioplayer.currentTrackIndex,
    deleteTrackActionData: state.myPlaylists.deleteMyPlaylistTrackActionData,
    deleteTrackLoading: state.myPlaylists.deleteMyPlaylistTrackLoading,
    playStatsTracks: state.playstats.tracks
  };
}, (0, _extends3.default)({}, audioplayerActions, myPlaylistsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(MyPlaylistTrack, _Component);

  function MyPlaylistTrack() {
    (0, _classCallCheck3.default)(this, MyPlaylistTrack);
    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistTrack.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistTrack)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyPlaylistTrack, [{
    key: 'getRenderProps',
    value: function getRenderProps() {
      var _props = this.props,
          track = _props.track,
          trackIndex = _props.trackIndex,
          deleteTrackLoading = _props.deleteTrackLoading,
          deleteTrackActionData = _props.deleteTrackActionData;

      var trackNumber = trackIndex + 1;
      var isDeleting = deleteTrackLoading && deleteTrackActionData.trackId === track.id;
      var isDenied = this.isTrackDenied();
      return { trackNumber: trackNumber, isDeleting: isDeleting, isDenied: isDenied };
    }
  }, {
    key: 'play',
    value: function play() {
      var _props2 = this.props,
          playAlbum = _props2.playAlbum,
          album = _props2.playlist,
          tracks = _props2.playlistTracks,
          currentTrackIndex = _props2.currentTrackIndex,
          trackIndex = _props2.trackIndex;

      playAlbum({ album: album, tracks: tracks, currentTrackIndex: (0, _defaultTo3.default)(trackIndex, currentTrackIndex) });
    }
  }, {
    key: 'bindPopover',
    value: function bindPopover(el) {
      this.popover = el;
    }
  }, {
    key: 'deleteTrack',
    value: function deleteTrack() {
      var _props3 = this.props,
          track = _props3.track,
          playlist = _props3.playlist,
          deleteMyPlaylistTrack = _props3.deleteMyPlaylistTrack;

      return deleteMyPlaylistTrack({ guid: playlist.guid, trackId: track.id });
    }
  }, {
    key: 'togglePopover',
    value: function togglePopover(e) {
      this.popover.toggle(e);
    }
  }, {
    key: 'isTrackDenied',
    value: function isTrackDenied() {
      var _props4 = this.props,
          track = _props4.track,
          playStatsTracks = _props4.playStatsTracks;

      return (0, _get3.default)(playStatsTracks, [track.id, 'isDenied']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          track = _props5.track,
          playlist = _props5.playlist;

      var _getRenderProps = this.getRenderProps(),
          trackNumber = _getRenderProps.trackNumber,
          isDeleting = _getRenderProps.isDeleting,
          isDenied = _getRenderProps.isDenied;

      return _react2.default.createElement(
        _ListItem2.default,
        {
          fullWidth: true,
          onClick: this.play,
          className: (0, _classnames2.default)(styles.track, (0, _defineProperty3.default)({}, styles.denied, isDenied))
        },
        _react2.default.createElement(
          'div',
          { className: styles.trackNumber },
          _react2.default.createElement(_TrackPlayPauseButton2.default, {
            track: track,
            album: playlist,
            showTrackNumber: true,
            trackNumber: trackNumber,
            isDenied: isDenied
          })
        ),
        _react2.default.createElement(_MyPlaylistTrackName2.default, { track: track }),
        _react2.default.createElement(_TrackDuration2.default, {
          track: track,
          album: playlist,
          className: styles.timeCell
        }),
        _react2.default.createElement(_MoreButton2.default, {
          onClick: this.togglePopover,
          loading: isDeleting,
          containerClass: styles.more,
          buttonClass: styles.moreButton
        }),
        _react2.default.createElement(_MyPlaylistTrackPopover2.default, {
          id: 'myPlaylistTrackPopover_' + track.id,
          onInit: this.bindPopover,
          onDelete: this.deleteTrack
        })
      );
    }
  }]);
  return MyPlaylistTrack;
}(_react.Component), _class3.propTypes = {
  currentTrackIndex: _propTypes2.default.number,
  deleteMyPlaylistTrack: _propTypes2.default.func,
  deleteTrackActionData: _propTypes2.default.object,
  deleteTrackLoading: _propTypes2.default.bool,
  playAlbum: _propTypes2.default.func,
  playlist: _propTypes2.default.object,
  playlistTracks: _propTypes2.default.array,
  playStatsTracks: _propTypes2.default.object,
  track: _propTypes2.default.object,
  trackIndex: _propTypes2.default.number
}, _class3.defaultProps = {
  playlist: {},
  playlistTracks: [],
  track: {},
  deleteTrackActionData: {}
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'play', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'play'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'bindPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'bindPopover'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteTrack', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteTrack'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'togglePopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'togglePopover'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = MyPlaylistTrack;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylist/components/MyPlaylistTrack.js
// module id = 2165
// module chunks = 1